import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {MedicalReportFieldsSchema} from '@/features/medical-reports/formSchemas'
import {PlannedAccessesProjectCountersCard} from '@/features/planned-accesses/components/planned-accesses-project-counters-card/PlannedAccessesProjectCountersCard'
import {PlannedAccessesPsychosocialCard} from '@/features/planned-accesses/components/planned-accesses-psychosocial-card/PlannedAccessesPsychosocialCard'
import {useAbsenceThreshold} from '@/features/planned-accesses/hooks/useAbsenceThreshold'
import {usePlannedAccessesFormCounts} from '@/features/planned-accesses/hooks/usePlannedAccessesFormCounts'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

export const ExtensionRequestTotalDetailsSchema = MedicalReportFieldsSchema.pick({
    projectId: true,
    plannedAccesses: true,
    newProjectDurationDays: true
})
type ExtensionRequestTotalDetailsSchema = z.infer<typeof ExtensionRequestTotalDetailsSchema>

export const ExtensionRequestTotalDetails = ({projectId}: {projectId: string}) => {
    const {control} = useFormContext<ExtensionRequestTotalDetailsSchema>()

    // Extract form values using useWatch
    const absenceAccesses = useWatch({control, name: 'plannedAccesses.absenceAccesses'}) || []
    const inPersonAccesses = useWatch({control, name: 'plannedAccesses.inPersonAccesses'}) || []
    const singleAccesses = useWatch({control, name: 'plannedAccesses.singleAccesses'}) || []
    const newProjectDurationDays = useWatch({control, name: 'newProjectDurationDays'})
    const {
        project,
        totalAbsencesAccessesCount,
        totalInPresenceAccessCount,
        totalPsychosocialAccessesCount,
        totalTreatmentAccessesCount
    } = usePlannedAccessesFormCounts({
        projectId,
        absenceAccesses,
        inPersonAccesses,
        singleAccesses,
        durationDays: newProjectDurationDays ?? 0
    })

    const {selectedAbsenceThresholdPercentage} = useAbsenceThreshold({
        assistiveRegime: project?.assistiveRegime ?? null,
        serviceType: project?.patient.serviceType ?? null,
        totalInPresenceAccessesCount: totalInPresenceAccessCount ?? 0
    })

    return (
        <Flexbox direction="column" gap={6}>
            <PlannedAccessesProjectCountersCard
                assistiveRegime={project?.assistiveRegime ?? null}
                serviceType={project?.patient.serviceType ?? null}
                totalInPresenceAccessCount={totalInPresenceAccessCount}
                totalAbsencesAccessesCount={totalAbsencesAccessesCount}
                selectedAbsenceThresholdPercentage={selectedAbsenceThresholdPercentage}
            />

            {/* todo: add medical card */}

            <PlannedAccessesPsychosocialCard
                totalTreatmentAccessesCount={totalTreatmentAccessesCount}
                totalPsychosocialAccessesCount={totalPsychosocialAccessesCount}
            />
        </Flexbox>
    )
}
